//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/TaggedObjectList.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[0,"Spine",0,"Curve",0],[1,"Stock",0,"SelectNXObject",0],[0,"TwistPoint",1,"Point",0],[1,"TwistPointList",0,"TaggedObjectList",0]],[[[],"CreateSpinePoint",{R_:{dimWithValueBuilder:"GeometricUtilities.OnPathDimWithValueBuilder"}},0,0],[[],"CreateSpine",{},0,0],[["numValues","locations","angles"],"AskExistingTwistData",{},0,0]],[]];
SPLM.Routing.RouteSweptTwistBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.RouteSweptTwistBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;